import {useEffect, useRef, useState} from "react";

// Мінімальний час показу спінера на всьому сайті: інакше на швидкій відповіді він лише блимає
export const MIN_SPIN_MS = 500;

/**
 * Повертає true, поки триває завантаження, і ще стільки, щоб спінер був видно щонайменше MIN_SPIN_MS.
 * Дані з'являються вчасно — затримується лише зникнення спінера.
 */
export const useMinSpin = (loading: boolean, minMs = MIN_SPIN_MS) => {
    const [shown, setShown] = useState(loading);
    const startedAt = useRef<number | null>(loading ? Date.now() : null);

    useEffect(() => {
        if (loading) {
            if (startedAt.current === null) startedAt.current = Date.now();
            setShown(true);
            return;
        }
        if (startedAt.current === null) return;

        const left = minMs - (Date.now() - startedAt.current);
        const hide = () => { startedAt.current = null; setShown(false); };
        if (left <= 0) { hide(); return; }
        const timer = window.setTimeout(hide, left);
        return () => window.clearTimeout(timer);
    }, [loading, minMs]);

    return loading || shown;
};
